import React from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../hooks/useTheme';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2.5 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl transition-all duration-300 group overflow-hidden"
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {/* Background Glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-solar-500/20 to-primary-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl" />
      
      {/* Icon Container */}
      <div className="relative z-10">
        {theme === 'light' ? (
          <MoonIcon className="w-5 h-5 transform group-hover:scale-110 transition-transform duration-300" />
        ) : (
          <SunIcon className="w-5 h-5 transform group-hover:scale-110 group-hover:rotate-90 transition-all duration-300" />
        )}
      </div>
      
      {/* Ripple Effect */}
      <div className="absolute inset-0 rounded-xl opacity-0 group-active:opacity-100 bg-white/20 dark:bg-gray-600/20 transition-opacity duration-150" />
    </button>
  );
};

export default ThemeToggle;